module.exports = __webpack_public_path__ + "static/media/google-small.eee99c55.png";